import React from 'react';
import { Box, TextField, Typography, Button, InputAdornment, Dialog, DialogTitle, DialogContent } from '@mui/material';

import useAdjustment from './useAdjustment';

const RequiredMarker = () => (
    <Box
        component="span"
        sx={{ color: (theme) => theme.palette.error.main }}
    >
        *
    </Box>
);

const Adjustment = ({ tuitionData = {}, onClose = () => {} }) => {
    const { doingAjax, description, adjustment, errors, updateDescription, updateAdjustment, saveAdjustment, deleteAdjustment } =
        useAdjustment(tuitionData);

    const handleSave = async () => {
        let validSave = await saveAdjustment();
        if (validSave) onClose(null, true);
    };

    const handleDelete = async () => {
        let validDelete = await deleteAdjustment();
        if (validDelete) onClose(null, true);
    };

    return (
        <Dialog open={true}>
            <DialogTitle>Adjust final payment</DialogTitle>
            <DialogContent>
                <Box>
                    <Typography>Add an adjustment to the payment record by completing the fields below.</Typography>

                    <Typography>School:</Typography>
                    <Box
                        sx={{
                            width: '75%',
                            color: (theme) => theme.palette.grey['field-text'],
                            backgroundColor: '#F5F7FF',
                            padding: '10px',
                            fontSize: '14px',
                            borderRadius: '8px',
                        }}
                    >
                        {tuitionData?.SchoolName || 'N/A'}
                    </Box>

                    <Typography>
                        <RequiredMarker /> Adjustment Description:
                    </Typography>
                    <TextField
                        size="small"
                        multiline
                        rows={4}
                        margin="dense"
                        sx={{
                            width: '78%',
                        }}
                        error={errors.includes('description')}
                        disabled={doingAjax}
                        value={description}
                        onChange={(event) => updateDescription(event.target.value)}
                    />

                    <Typography>
                        <RequiredMarker /> Adjustment Amount:
                    </Typography>
                    <TextField
                        size="small"
                        margin="dense"
                        autoComplete="off"
                        InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                        error={errors.includes('adjustment')}
                        value={adjustment}
                        disabled={doingAjax}
                        onChange={(event) => updateAdjustment(event.target.value)}
                        onBlur={(event) => updateAdjustment(event.target.value, 'blur')}
                    />
                </Box>
                <Box>
                    <Button
                        variant="contained"
                        color="error"
                        disabled={doingAjax || tuitionData?.AdjustmentAmount === null}
                        onClick={() => handleDelete()}
                    >
                        Delete
                    </Button>

                    <Button
                        variant="contained"
                        onClick={() => onClose?.()}
                        disabled={doingAjax}
                    >
                        Close
                    </Button>

                    <Button
                        variant="contained"
                        onClick={() => handleSave()}
                        disabled={doingAjax}
                    >
                        Save changes
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default Adjustment;
